module.exports = __webpack_public_path__ + "static/img/190405-hormones.52366ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gensunicerse/190405-hormones.jpg
// module id = N/gO
// module chunks = 0